exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\nbutton[data-v-30be3004] {\n  padding: 3px;\n}\n", ""]);

// exports
